export default __webpack_public_path__ + "static/media/map-singapore-small.4bc530a2.jpg";